<template>
  <div>
    <location />
    <div class="page">
      <tab />
      <div class="tab-content wrap-1200" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="pills-2"
          role="tabpanel"
          aria-labelledby="pills-2-tab"
        >
          <h3 class="subtitle">
            <div class="badge-group">
              <span class="badge tourn-type">
                {{ tournament_type(tournamentinfo.type) }} </span
              >
              <p class="tourn-title">
                {{ tournamentinfo.title }}
              </p>
            </div>
          </h3>
          <p class="info">{{ tournamentinfo.remark }}</p>

          <div
            class="row row-cols-1 row-cols-md-auto gy-2 text-date fs-14 lh-sm"
          >
            <div class="col">
              <!-- 서비스 시간 -->

              {{
                tournamentinfo.timezone_startdate &&
                tournamentinfo.timezone_startdate.timezone_common
                  | dateformat("YYYY.MM.DD")
              }}
              ~
              {{
                tournamentinfo.timezone_enddate &&
                tournamentinfo.timezone_enddate.timezone_common
                  | dateformat("YYYY.MM.DD")
              }}
            </div>
          </div>

          <div class="border-top-dgray mt-4">
            <div class="row g-0">
              <div
                class="col-lg-2 row g-0 bg-gray border-bottom align-items-center"
              >
                <label class="d-table-cell">{{
                  $t("title.common.location")
                }}</label>
              </div>
              <div class="col-lg-10 border-bottom">
                <p class="d-table-cell shop-name">
                  <span v-for="(shop, index2) in tournamentshop" :key="index2"
                    >{{ index2 === 0 ? "" : " / "
                    }}{{ shop.shopname || "Unregistered" }}</span
                  >
                </p>
              </div>
            </div>
            <div class="row g-0 border-bottom">
              <div
                class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center"
              >
                <label class="d-table-cell">{{
                  $t("title.common.course")
                }}</label>
              </div>
              <div class="col-8 col-lg-10">
                <p class="d-table-cell">
                  <span v-for="(course, index) in tournamentcourse" :key="index"
                    >{{ index === 0 ? "" : ", " }}{{ course.coursename }}</span
                  >
                </p>
              </div>
            </div>

            <div class="row g-0 border-bottom">
              <div class="row g-0 col-4 col-lg-2 bg-gray align-item-center">
                <label class="d-table-cell align-self-center">{{
                  $t("title.common.subcourse")
                }}</label>
              </div>
              <div v-if="subcourselistcnt" class="col-8 col-lg-10">
                <div
                  v-for="(anc, index1) in subcourselist"
                  :key="'k_' + index1"
                  class="subcourse"
                >
                  <h6 class="pt-1">{{ anc.subcoursename }}</h6>
                  <small class="d-block text-dgray"
                    >{{ $t("text.common.subcourse") }}
                    {{ anc.subcourseseq }}</small
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="border-top-dgray mt-5">
            <div class="row g-0">
              <div
                class="col-lg-2 row g-0 bg-gray border-bottom align-items-center"
              >
                <label class="d-table-cell">{{
                  $t("title.common.prizes")
                }}</label>
              </div>
              <div class="col-lg-10 border-bottom">
                <div class="row g-0 border-bottom">
                  <div class="col-lg-12">
                    <p class="d-table-cell">
                      {{ tournamentprizeetc.etcprize || "Unregistered" }}
                    </p>
                  </div>
                </div>
                <div class="row g-0 border-bottom-0">
                  <div class="col-lg-12">
                    <p class="d-table-cell">
                      <span
                        class="d-block"
                        v-for="(rank, index3) in tournamentprizerank"
                        :key="index3"
                        ><strong class="fw-500 text-black"
                          >Top {{ rank.rankno }}</strong
                        >
                        :
                        <span class="text-point">{{
                          rank.rankprize | comma
                        }}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-0">
              <div
                class="col-lg-2 bg-gray row g-0 align-items-center border-bottom"
              >
                <label class="d-table-cell">{{
                  $t("title.common.tournament_conditions")
                }}</label>
              </div>
              <div class="col-lg-10">
                <div class="row g-0 border-bottom-0">
                  <div
                    class="col-lg-6 d-table-cell d-flex flex-column align-items-stretch"
                  >
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.game_mode")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">
                          {{ tournamentdetail.mode }}
                        </p>
                      </div>
                    </div>
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.level")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">
                          {{ tournament_level(tournamentdetail.level) }}
                        </p>
                      </div>
                    </div>
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.greenspeed")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">
                          {{ tournamentinfo.greenspeed_fk | greenspeed }}
                        </p>
                      </div>
                    </div>                    
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.entry_limit")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell text-red">
                          {{ tournamentinfo.entrylimit | transToValue("∞") }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="row g-0 border-bottom d-flex flex-row align-items-stretch h-100"
                    >
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.mulligan")
                        }}</label>
                      </div>
                      <div class="col-7 row align-items-center">
                        <p class="d-table-cell">
                          {{ tournamentdetail.mulligan }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-lg-6 d-table-cell d-flex flex-column align-items-stretch"
                  >
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.play_format")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">{{ tournamentdetail.hole }}H</p>
                      </div>
                    </div>
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.wind")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">{{ wind }}</p>
                      </div>
                    </div>
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.greengravity")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">
                          {{ tournamentinfo.greengravity_fk | greengravity }}
                        </p>
                      </div>
                    </div>                    
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">-</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell"></p>
                      </div>
                    </div>
                    <div class="row g-0 border-bottom">
                      <div
                        class="col-5 bg-lightgray row g-0 align-items-center"
                      >
                        <label class="d-table-cell">{{
                          $t("title.common.teebox")
                        }}</label>
                      </div>
                      <div class="col-7">
                        <p class="d-table-cell">
                          {{ $t("title.common.male") }} : {{ teemale }}<br />
                          {{ $t("title.common.female") }} : {{ teefemale }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="row g-0 border-bottom-0">
                  <div class="col-lg-3 bg-gray row align-items-center">
                    <label class="d-table-cell">Handicap(No. of Play)</label>
                  </div>
                  <div class="col-lg-9">
                    <p class="d-table-cell">
                      {{ tournamentdetail.playhandicap }}
                    </p>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0" v-if="Object.keys(shop_handi_num).length > 0">
          <div
            class="col-lg-2 row g-0 bg-gray border-bottom align-items-center"
          >
            <label class="d-table-cell">매장 핸디캡 참여횟수</label>
          </div>
          <div class="col-lg-10 d-block border-bottom" style="padding: 0.75rem">
            <div class="row row-cols-2 row-cols-lg-5 gx-2 gy-3">
              <div
                class="col"
                v-for="(handicap, playingcount) in shop_handi_num"
                :key="playingcount"
              >
                <p class="mb-1 fw-500 fs-14">{{ playingcount }}회</p>
                <input
                  type="text"
                  class="text-point"
                  :value="handicap"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            :aria-label="$t('button.common.list')"
            @click="click_list()"
            >{{ $t("button.common.list") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import location from "@/components/Location";
import tab from "@/components/membership/Tab";
import ax from "@/api/membership";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "MyTournamentsView",
  components: {
    location,
    tab,
  },
  data() {
    return {
      tournamentno: this.$route.params.id,
      tournamentinfo: [
        {
          title: "",
          remark: "",
          startdate: "",
          enddate: "",
        },
      ],
      tournamentcourse: [],
      tournamentshop: [],
      tournamentprizeetc: [
        {
          etcprize: "",
        },
      ],
      tournamentprizerank: [],
      tournamentdetail: [
        {
          mode: "",
          hole: "",
          level: "",
          wind: "",
          mulligan: "",
          teeboxman: "",
          teeboxwoman: "",
          playhandicap: "",
        },
      ],
      wind: "",
      teemale: "",
      teefemale: "",
      subcourselist: [],
      subcourselist: [],
      tourbinary: [],
      subcourselistcnt: 0,
      shop_handi_num: {},
    };
  },
  methods: {
    get_membertournamentcondition() {
      ax.get_membertournamentcondition(this.tournamentno, (flag, data) => {
        if (flag) {
          this.tournamentinfo = data.tournamentinfo;
          this.tournamentcourse = data.tournamentcourse;
          this.tournamentshop = data.tournamentshop;
          this.tournamentprizeetc = data.tournamentprizeetc;
          this.tournamentprizerank = data.tournamentprizerank;
          this.tournamentdetail = data.tournamentdetail;
          this.subcourselist = data.subcourselist;
          this.subcourselistcnt = data.subcourselistcnt;
          this.tourbinary = data.tourbinary;
          this.change_wind(this.tournamentdetail.wind);
          this.change_male(this.tournamentdetail.teeboxman);
          this.change_female(this.tournamentdetail.teeboxwoman);
          data.shophandilist.forEach(({ playingcount, handicap }) => {
            this.$set(this.shop_handi_num, playingcount, handicap);
          });
        } else {
          alert(data);
        }
      });
    },
    click_list() {
      this.$router.push({
        name: "MyTournaments",
        query: {
          startdate: this.$route.query.startdate,
          enddate: this.$route.query.enddate,
        },
      });
    },
    //   change_wind(wind) {
    //     if (wind === "0") {
    //       this.wind = this.$i18n.t("text.common.calm");
    //     } else if (wind === "1") {
    //       this.wind = this.$i18n.t("text.common.light");
    //     } else if (wind === "2") {
    //       this.wind = this.$i18n.t("text.common.moderate");
    //     } else if (wind === "3") {
    //       this.wind = this.$i18n.t("text.common.strong");
    //     } else if (wind === "4") {
    //       this.wind = this.$i18n.t("text.common.random");
    //     } else {
    //       this.wind = wind;
    //     }
    //   },
    //   change_male(teeboxman) {
    //     if (teeboxman === "1") {
    //       this.teemale =
    //         this.$i18n.t("text.common.pro") +
    //         "(" +
    //         this.$i18n.t("text.common.blue") +
    //         ")";
    //     } else if (teeboxman === "2") {
    //       this.teemale =
    //         this.$i18n.t("text.common.regular") +
    //         "(" +
    //         this.$i18n.t("text.common.white") +
    //         ")";
    //     } else if (teeboxman === "3") {
    //       this.teemale =
    //         this.$i18n.t("text.common.lady") +
    //         "(" +
    //         this.$i18n.t("text.common.red") +
    //         ")";
    //     } else {
    //       this.teemale = teeboxman;
    //     }
    //   },
    //   change_female(teeboxwoman) {
    //     if (teeboxwoman === "1") {
    //       this.teefemale =
    //         this.$i18n.t("text.common.pro") +
    //         "(" +
    //         this.$i18n.t("text.common.blue") +
    //         ")";
    //     } else if (teeboxwoman === "2") {
    //       this.teefemale =
    //         this.$i18n.t("text.common.regular") +
    //         "(" +
    //         this.$i18n.t("text.common.white") +
    //         ")";
    //     } else if (teeboxwoman === "3") {
    //       this.teefemale =
    //         this.$i18n.t("text.common.lady") +
    //         "(" +
    //         this.$i18n.t("text.common.red") +
    //         ")";
    //     } else {
    //       this.teefemale = teeboxwoman;
    //     }
    //   },
  },
  created() {
    this.get_membertournamentcondition();
  },
  mixins: [myMixin],
};
</script>
